// Values sourced from client-common/src/lib/unitConversion.ts (keep in sync)
export const IMPERIAL = {
  defaults: {
    minFt: 2,
    maxFt: 8,
    minIn: 0,
    maxIn: 11,
    minSt: 6,
    maxSt: 47,
    minLb: 0,
    maxLb: 13,
  },
  labels: {
    cm: "cm",
    kg: "kg",
    ft: "ft",
    in: "in",
    st: "st",
    lb: "lb",
    ftIn: "ft / in",
    stLb: "st / lb",
    feet: "feet",
    inches: "inches",
    stones: "stones",
    pounds: "pounds",
  },
} as const;

export const LB_TO_KG = 0.45359237;
const LB_PER_ST = 14;
export const IN_TO_CM = 2.54;
const IN_PER_FT = 12;

export function kgToImperial(kg: number): { st: number; lb: number } {
  const totalLb = kg / LB_TO_KG;
  let st = Math.floor(totalLb / LB_PER_ST);
  let lb = Math.round(totalLb % LB_PER_ST);
  if (lb === LB_PER_ST) { st += 1; lb = 0; }
  return { st, lb };
}

export function imperialToKg(st: number, lb: number): number {
  return (st * LB_PER_ST + lb) * LB_TO_KG;
}

export function cmToImperial(cm: number): { ft: number; inches: number } {
  const totalIn = cm / IN_TO_CM;
  let ft = Math.floor(totalIn / IN_PER_FT);
  let inches = Math.round(totalIn % IN_PER_FT);
  if (inches === IN_PER_FT) { ft += 1; inches = 0; }
  return { ft, inches };
}

export function imperialToCm(ft: number, inches: number): number {
  return (ft * IN_PER_FT + inches) * IN_TO_CM;
}

// The precision imperial answers are stored at (same as ImperialNumberField): kg to 1 decimal, cm whole.
export const imperialToStoredKg = (st: number, lb: number): number => parseFloat(imperialToKg(st, lb).toFixed(1));
export const imperialToStoredCm = (ft: number, inches: number): number => Math.round(imperialToCm(ft, inches));
